import styled, { css, useTheme } from "styled-components";
import { useEffect, useState } from "react";
import { lighten, rgba } from "polished";
import LIQUIBOT_LOGO from "../../../../Icons/LiquiBotLogo.png";
import { ids, menuOptions } from "../../../../Components/NavBar/NavBar";

export const Footercontainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 10rem;
    ${({ theme }) => css`
        color: ${theme.colors.text};
        gap: 1rem;
        padding-top: 10rem;
        padding-bottom: 5rem;
        transition: ${theme.animationTime.short}s all ease;
        background: ${theme.colors.background};
    `}
`;

const LogoNameContainer = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
`;
const Logo = styled.img`
    width: 30px;
    height: 30px;
    border-radius: 50%;
`;
const Name = styled.div`
    font-weight: 600;
    ${({ theme }) => css`
        font-size: ${theme.fontSize.medium * 0.9}px;
    `}
`;

const MainFooterItems = styled.div`
    display: flex;
    justify-content: space-between;
    width: 90%;
    ${({ theme }) => css`
        @media screen and (max-width: ${theme.breakpoint}px) {
            flex-direction: column;
            gap: 1rem;
        }
    `}
`;
const ExtraFooterItems = styled.div`
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin-top: 1rem;
    padding-top: 0.5rem;
    ${({ theme }) => css`
        border-top: 1px solid
            ${rgba(lighten(0.1, theme.colors.discordBlue), 0.3)};
        @media screen and (max-width: ${theme.breakpoint}px) {
            flex-direction: column;
            justify-content: center;
            gap: 0.2rem;
        }
    `}
`;
const ExtraItem = styled.div`
    font-weight: 300;
    opacity: 0.6;
    text-align: center;
`;

const BottomLinks = styled.div`
    display: flex;
    justify-content: center;
    gap: 1rem;
`;
const BottomLink = styled.a``;
const BottomLinkIcon = styled.img`
    width: 20px;
    height: 20px;
`;

const LinkColumns = styled.div`
    display: flex;
    gap: 5rem;
    ${({ theme }) => css`
        @media screen and (max-width: ${theme.breakpoint}px) {
            flex-direction: column;
            gap: 1rem;
        }
    `}
`;

const Column = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
`;
const ColumnTitle = styled.div`
    font-weight: 600;
    padding-bottom: 0.1rem;
    ${({ theme }) => css`
        border-bottom: 1px solid ${theme.colors.discordBlue};
        @media screen and (max-width: ${theme.breakpoint}px) {
            width: 50%;
        }
    `}
`;
const Scroller = styled.div`
    cursor: pointer;
`;
const OtherLink = styled.a`
    color: inherit;
    text-transform: capitalize;
    text-decoration: none;
`;

const links: { [key: string]: string } = {
    invite: "https://discord.com/oauth2/authorize?client_id=1074436572172259500&permissions=8&scope=bot",
    dashboard: "https://liquidash.netlify.app/",
};

export const Footer = () => {
    const [year, setYear] = useState(0);
    useEffect(() => {
        setYear(new Date().getFullYear());
    }, []);
    const theme = useTheme();
    const scrollTo = (id: string) => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    };
    return (
        <Footercontainer id="footer-container">
            <MainFooterItems>
                <LogoNameContainer>
                    <Logo src={LIQUIBOT_LOGO} />
                    <Name>LiquiBot</Name>
                </LogoNameContainer>
                <LinkColumns>
                    <Column>
                        <ColumnTitle>Page Sections</ColumnTitle>
                        {menuOptions.map((option, idx) => {
                            return (
                                <Scroller
                                    key={idx}
                                    onClick={() => scrollTo(ids[idx])}
                                >
                                    {option}
                                </Scroller>
                            );
                        })}
                    </Column>
                    <Column>
                        <ColumnTitle>Other Links</ColumnTitle>
                        {Object.keys(links).map((key) => (
                            <OtherLink href={links[key]} target="_blank">
                                {key}
                            </OtherLink>
                        ))}
                    </Column>
                </LinkColumns>
            </MainFooterItems>
            <ExtraFooterItems>
                <ExtraItem>&copy;{year} All rights reserved.</ExtraItem>
                <BottomLinks>
                    <BottomLink>
                        <BottomLinkIcon src={theme.icons.discord} />
                    </BottomLink>
                </BottomLinks>
            </ExtraFooterItems>
        </Footercontainer>
    );
};
